<template>
  <div class="about">
    <ParameterStripe />
    <Map />
  </div>
</template>

<script>
// @ is an alias to /src
import ParameterStripe from "@/components/ParameterStripe.vue";
import Map from "@/components/Map.vue";

export default {
  name: "About",
  components: {
    ParameterStripe,
    Map,
  },
};
</script>
